import { useEffect, useState } from "react";
import "./App.css";
import { Footer } from "./components/Footer/Footer";
import { ModalContainer } from "./components/ModalContainer/ModalContainer";
import { InteractiveContentModal } from "./components/InteractiveContentModal/InteractiveContentModal";
import { Sidebar } from "./components/Sidebar/Sidebar";
import { appConfig } from "./config";
import { exitFullscreen, goFullScreen } from "./utils/fullscreenHelper";
import { useWindowSize } from "./utils/newScreenHeightHelper";
import { initGA } from "./utils/googleAnalyticsHelper";

function App() {
  const [windowWidth, windowHeight] = useWindowSize();
  const { VistaComponent } = appConfig;
  const [openInteractiveContent, setOpenInteractiveContent] = useState(false);

  useEffect(() => {
    function callback(e) {
      if (e.data.fullscreen) {
        goFullScreen();
      } else if (e.data.exit) {
        exitFullscreen();
      }
    }
    window.addEventListener("message", callback);

    return () => {
      window.removeEventListener("message", callback);
    };
  }, []);

  const [vistaContent, setVistaContent] = useState(null);

  const getIframe = (iframe) => {
    setVistaContent(iframe);
    return iframe;
  };

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    function callback(e) {
      if (e.data.message) {
        setOpenInteractiveContent(!openInteractiveContent);
      }
    }
    window.addEventListener("message", callback);

    return () => {
      window.removeEventListener("message", callback);
    };
  }, []);

  const handleInteractiveContent = () => {
    setOpenInteractiveContent(false);
  };

  return (
    <div className="App" style={{ height: windowHeight, width: windowWidth }}>
      <Sidebar />
      <ModalContainer vistaContent={vistaContent} />
      {openInteractiveContent && <InteractiveContentModal closeModal={handleInteractiveContent} />}
      <VistaComponent getIframe={getIframe} />
      <Footer />
    </div>
  );
}

export default App;
